module.exports = __webpack_public_path__ + "img/bg-audio.e5a10b65.svg";